
import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import get from 'lodash/get';

import {
    IfComp
} from '../../core';

import { getActions } from '../sagas';
import { getInfo } from '../reducers'

import { INFO_TYPE_HOME } from '../reducers/infoPanelType';
import { getCoordinates } from '../reducers/info'

import ExternalMapLinks from './ExternalMapLinks';

const ObjectInfoNo = ({appActions, appConfig}) => {

    const classNames = mergeStyleSets({
        ObjectInfoNo: {
        },
    });

    const dispatch = useDispatch();
    const dataActions = getActions(dispatch);

    const coordinates = useSelector(state => getCoordinates(getInfo(state.data)));

    const handleCloseClick = () => {
        dataActions.setType(INFO_TYPE_HOME);
    }

    const externalMapLinks = get(appConfig, 'externalMapLinks');

    return (
        <Stack verticalFill className={classNames.ObjectInfoNo} tokens={{childrenGap: 4}}>
            <div>Žádné informace nejsou k dispozici</div>
            <IfComp 
                cond={(
                    coordinates &&
                    externalMapLinks && 
                    (externalMapLinks.length > 0)
                )}
                >
                <ExternalMapLinks 
                    coordinates={coordinates}
                    externalMapLinks={externalMapLinks} 
                />
            </IfComp>
            <Stack horizontal horizontalAlign="end" tokens={{childrenGap: 8}}>
                <Link onClick={handleCloseClick} title="Zpět na úvodní stránku Datového panelu">Zpět</Link>
            </Stack>
        </Stack>
    );
}

export default ObjectInfoNo;
